<template>
  <div class="">
    <div v-if="!isHorizontal">{{ field.name }}</div>
    <!-- <b-form-timepicker
      :id="uniqueId"
      v-model="time"
      :disabled="isFieldDisabled"
      class="timeNoBackground w-100"
      @input="onChange"
      trim
      placeholder=""
    /> -->
    <flat-pickr
      :id="uniqueId"
      class="timeNoBackground w-100"
      :config="{
        enableTime: true,
        dateFormat: 'H:i',
        time_24hr: true,
        noCalendar: true,
        enableSeconds: false,
        onOpen: setCurrentTime
      }"
      v-model="time"
      :disabled="isFieldDisabled"
      @input="onChange"
    />
    <div class="d-flex flex-column">
      <span class="textHint" v-if="hint">{{ hint }}</span>
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const isFieldDisabled = ref(false);
    const time = ref("");
    const hint = ref("");
    const error = ref(null);

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    onMounted(async () => {
      hint.value = props?.field?.options?.fieldTypeCfg?.data[0]?.hint;
      isFieldDisabled.value = props.isFormDisabled

      const now = new Date();
      const localTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[1]
        .slice(0, 5);
      const showEmpty = props?.field?.options?.fieldTypeCfg?.data[0]?.showEmpty
      time.value = showEmpty ? '' : localTime
    });

    function onChange() {
      emit("updateData", props.field, time.value);
    }

    function setCurrentTime(selectedDates, dateStr, instance) {
      if (time.value) return;
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      time.value = `${hours}:${minutes}`
      instance.setDate(time.value, true)
    }

    return {
      uniqueId,
      isFieldDisabled,
      time,
      hint,
      error,
      onChange,
      setCurrentTime
    }
  }
}
</script>
<style scoped lang="scss">
.text-error {
  color: #ec0303;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  padding: 0.75em;
  margin: 0;
  background-color: #fff !important;
}
.dark-layout {
  .timeNoBackground {
    background-color: var(--second-dark) !important;
    color: #fff;
  }
}
</style>